import { api } from "@/http/api-client"
import type { TPerson } from "./types"

export type TGetPersonParams = {
  id: string
  organizationSlug: string
}

export function getPerson(params: TGetPersonParams) {
  const searchParams = new URLSearchParams({
    organizationSlug: params.organizationSlug,
  })

  return api.get<TPerson>(`/peoples/${params.id}?${searchParams.toString()}`)
}
